import { useBackend } from '@/hooks/useBackend';
import { useInternalApiFilterParams } from '@/hooks/useInternalApiFilterParams';
import { FacetFilter } from '@/pages/explorer/filters/FacetFilter';

export function InternalApiFilter() {
  const filterParams = useInternalApiFilterParams();

  const { data: apiFacets } = useBackend(
    '/apis/internal/facets',
    { params: { query: filterParams } },
    { keepPreviousData: true },
  );

  if (!apiFacets) return null;

  return (
    <div className="flex flex-col gap-2">
      <FacetFilter filterKey="stage" label="Stage" values={apiFacets.stage} />
      <FacetFilter filterKey="classification" label="Classification" values={apiFacets.classification} />
      <FacetFilter filterKey="serviceDomainId" label="Service Domain" values={apiFacets.serviceDomainId} />
      <FacetFilter filterKey="tags" label="Tags" values={apiFacets.tags} />
    </div>
  );
}
